"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteJiraInitiativesUnlinkIssueSlice = void 0;
const _api_1 = require("../../../../api/index.js");
const remove_1 = require("../@sync/remove.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.deleteJiraInitiativesUnlinkIssueSlice = (0, xuder_1.createDeleteAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.JIRA_ISSUE_UNLINKED, (action) => action.data),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request) => remove_1.initiativesJiraIssueRemoveSyncSlice.syncActionCreator({
                customerId: request.customerId,
                initiativeId: request.initiativeId,
                issueKey: request.issueKey
            })
        ]
    },
    name: 'jiraInitiativesUnlinkIssue',
    receive: false,
    request: true,
    requestHandler: _api_1.deleteInitiativesUnlinkJira
});
//# sourceMappingURL=delete.js.map